import React, { useState } from 'react';
import AbstractClaimGroupChildPage from '@rd-web-markets/shared/dist/pages/abstract/AbstractClaimGroupChildPage';
import AppWizard from '../wizard/AppWizard';
import ChooseUploadOrDownloadStep from './wizard_steps/ChooseUploadOrDownloadStep';
import DownloadDataStep from './wizard_steps/DownloadDataStep';
import DownloadProjectDataStep from './wizard_steps/DownloadProjectDataStep';
import DownloadCostDataStep from './wizard_steps/DownloadCostDataStep';
const DataCentreWizardPage = AbstractClaimGroupChildPage({
  highlightedMenuItem: 'files',
  ClaimGroupChildPage: function (_ref) {
    let {
      claimGroup
    } = _ref;
    const stepConfig = {
      ChooseUploadOrDownloadStep: {
        index: 0,
        key: 'choose_upload_download',
        render: NavigationContext => /*#__PURE__*/React.createElement(ChooseUploadOrDownloadStep, {
          claimGroup: claimGroup,
          stepConfig: stepConfig,
          NavigationContext: NavigationContext
        })
      },
      DownloadDataStep: {
        index: 1,
        key: 'download_data',
        render: NavigationContext => /*#__PURE__*/React.createElement(DownloadDataStep, {
          claimGroup: claimGroup,
          stepConfig: stepConfig,
          NavigationContext: NavigationContext
        })
      },
      DownloadProjectDataStep: {
        index: 2,
        key: 'download_project_data',
        render: NavigationContext => /*#__PURE__*/React.createElement(DownloadProjectDataStep, {
          claimGroup: claimGroup,
          stepConfig: stepConfig,
          NavigationContext: NavigationContext
        })
      },
      DownloadCostDataStep: {
        index: 3,
        key: 'download_cost_data',
        render: NavigationContext => /*#__PURE__*/React.createElement(DownloadCostDataStep, {
          claimGroup: claimGroup,
          stepConfig: stepConfig,
          NavigationContext: NavigationContext
        })
      }
    };
    return /*#__PURE__*/React.createElement(AppWizard, {
      stepConfig: stepConfig
    });
  }
});
export default DataCentreWizardPage;